import ReactMarkdown from 'react-markdown/with-html';
import { MarkdownAbstractSyntaxTree, ReactMarkdownProps } from 'react-markdown';
import breaks from 'remark-breaks';
import visit from 'unist-util-visit';

import renderers from './renderers';

const AD_KEY_REGEX = /\{ad type="(?<type>.+)"\}/;

function ads(tree: MarkdownAbstractSyntaxTree): MarkdownAbstractSyntaxTree {
  visit(tree as any, 'text', (node, _, parent) => {
    // not sure why the type def doesn't have value, it appears to exist
    // in practicality
    const matches = (node.value as string).match(AD_KEY_REGEX);
    if (matches?.groups && parent) {
      // eslint-disable-next-line no-param-reassign
      parent.type = 'ad';
      // eslint-disable-next-line no-param-reassign
      parent.value = matches.groups.type;
    }
  });
  return tree;
}

export default function ContentfulMarkdown(props: ReactMarkdownProps): JSX.Element {
  return (
    <ReactMarkdown
      {...props}
      astPlugins={[ads]}
      plugins={[breaks]}
      escapeHtml={false}
      renderers={renderers}
    />
  );
}
